import { render, staticRenderFns } from "./deletedRealEstates.vue?vue&type=template&id=718eedad&scoped=true&"
import script from "./deletedRealEstates.vue?vue&type=script&lang=js&"
export * from "./deletedRealEstates.vue?vue&type=script&lang=js&"
import style0 from "./deletedRealEstates.vue?vue&type=style&index=0&id=718eedad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718eedad",
  null
  
)

export default component.exports